import React from "react";
import { FunctionalStreamRenderer as StreamRenderer } from "./FunctionalStreamRenderer";
import AddParticipantPopover from "./AddParticipantPopover";
import RemoteParticipantCard from "./RemoteParticipantCard";
import LocalVideoPreviewCard from './LocalVideoPreviewCard';
import { LocalVideoStream, Features, LocalAudioStream } from '@azure/communication-calling';
import { utils } from '../Utils/Utils';
import CustomVideoEffects from "./RawVideoAccess/CustomVideoEffects";
import VideoEffectsContainer from './VideoEffects/VideoEffectsContainer';
import VolumeVisualizer from "./VolumeVisualizer";
import { Button, Col, Drawer, Dropdown, Icon, message, PageHeader, Row, Switch, Tooltip } from "antd";
import { maximizePopUpout, minimizePopUpout, MinMaxButton } from "../Index";
import MiCompAPI from "../../../util/api";
import { createChatThread } from "../ChatandCall";
export default class CallCard extends React.Component {
    constructor(props) {
        super(props);
        this.callFinishConnectingResolve = undefined;
        this.call = props.call;
        this.deviceManager = props.deviceManager;
        this.remoteVolumeLevelSubscription = undefined;
        this.handleRemoteVolumeSubscription = undefined;
        this.maximumNumberOfRenderers = 6;
        this.userPermandMasters = this.props.userPermandMasters;
        this.state = {
            callState: this.call.state,
            callId: this.call.id,
            remoteParticipants: this.call.remoteParticipants,
            allRemoteParticipantStreams: [],
            videoOn: this.call.localVideoStreams[0],
            micMuted: false,
            incomingAudioMuted: false,
            onHold: this.call.state === 'LocalHold' || this.call.state === 'RemoteHold',
            screenShareOn: this.call.isScreenShareOn,
            outgoingAudioMediaAccessActive: false,
            cameraDeviceOptions: props.cameraDeviceOptions ? props.cameraDeviceOptions : [],
            speakerDeviceOptions: props.speakerDeviceOptions ? props.speakerDeviceOptions : [],
            microphoneDeviceOptions: props.microphoneDeviceOptions ? props.microphoneDeviceOptions : [],
            selectedCameraDeviceId: props.selectedCameraDeviceId,
            selectedSpeakerDeviceId: this.deviceManager.selectedSpeaker && this.deviceManager.selectedSpeaker.id,
            selectedMicrophoneDeviceId: this.deviceManager.selectedMicrophone && this.deviceManager.selectedMicrophone.id,
            showSettings: false,
            showLocalVideo: false,
            dominantSpeakerMode: false,
            dominantRemoteParticipant: undefined,
            logMediaStats: false,
            sentResolution: '',
            remoteVolumeIndicator: undefined,
            remoteVolumeLevel: undefined,
            mediaCollector: undefined,
            minimize: false,
            isRecording: 'stop',
            serverCallId: undefined,
            recordingId: undefined,
            paused: 'play',
            participants: []
        };
        this.audio = props.audio;
        this.thread = props.thread;
        this.api = new MiCompAPI(this.userPermandMasters);
    }

    componentWillUnmount() {
        this.call.off('stateChanged', () => { });
        this.deviceManager.off('videoDevicesUpdated', () => { });
        this.deviceManager.off('audioDevicesUpdated', () => { });
        this.deviceManager.off('selectedSpeakerChanged', () => { });
        this.deviceManager.off('selectedMicrophoneChanged', () => { });
        this.call.off('localVideoStreamsUpdated', () => { });
        this.call.off('idChanged', () => { });
        this.call.off('isMutedChanged', () => { });
        this.call.off('isIncomingAudioMutedChanged', () => { });
        this.call.off('isScreenSharingOnChanged', () => { });
        this.call.off('remoteParticipantsUpdated', () => { });
        if (this.state.mediaCollector) {
            this.state.mediaCollector.off('sampleReported', () => { });
            this.state.mediaCollector.off('summaryReported', () => { });
        }

        this.call.feature(Features.DominantSpeakers).off('dominantSpeakersChanged', () => { });
    }

    componentDidMount() {
        if (this.call) {
            this.deviceManager.on('videoDevicesUpdated', async e => {

                let newCameraDeviceToUse = undefined;
                e.added.forEach(addedCameraDevice => {
                    newCameraDeviceToUse = addedCameraDevice;
                    const addedCameraDeviceOption = { key: addedCameraDevice.id, text: addedCameraDevice.name };
                    this.setState(prevState => ({
                        cameraDeviceOptions: [...prevState.cameraDeviceOptions, addedCameraDeviceOption]
                    }));
                });
                // When connecting a new camera, ts device manager automatically switches to use this new camera and
                // this.call.localVideoStream[0].source is never updated. Hence I have to do the following logic to update
                // this.call.localVideoStream[0].source to the newly added camera. This is a bug. Under the covers, this.call.localVideoStreams[0].source
                // should have been updated automatically by the sdk.
                if (newCameraDeviceToUse) {
                    try {
                        await this.call.localVideoStreams[0] && this.call.localVideoStreams[0].switchSource(newCameraDeviceToUse);
                        this.setState({ selectedCameraDeviceId: newCameraDeviceToUse.id });
                    } catch (error) {
                        console.error('Failed to switch to newly added video device', error);
                    }
                }

                e.removed.forEach(removedCameraDevice => {
                    this.setState(prevState => ({
                        cameraDeviceOptions: prevState.cameraDeviceOptions.filter(option => { return option.key !== removedCameraDevice.id })
                    }))
                });

                // If the current camera being used is removed, pick a new random one
                if (!this.state.cameraDeviceOptions.find(option => { return option.key === this.state.selectedCameraDeviceId })) {
                    const newSelectedCameraId = this.state.cameraDeviceOptions[0] && this.state.cameraDeviceOptions[0].key;
                    const cameras = await this.deviceManager.getCameras();
                    const videoDeviceInfo = cameras.find(c => { return c.id === newSelectedCameraId });
                    await this.call.localVideoStreams[0] && this.call.localVideoStreams[0].switchSource(videoDeviceInfo);
                    this.setState({ selectedCameraDeviceId: newSelectedCameraId });
                }
            });

            this.deviceManager.on('audioDevicesUpdated', e => {

                e.added.forEach(addedAudioDevice => {
                    const addedAudioDeviceOption = { key: addedAudioDevice.id, text: addedAudioDevice.name };
                    if (addedAudioDevice.deviceType === 'Speaker') {
                        this.setState(prevState => ({
                            speakerDeviceOptions: [...prevState.speakerDeviceOptions, addedAudioDeviceOption]
                        }));
                    } else if (addedAudioDevice.deviceType === 'Microphone') {
                        this.setState(prevState => ({
                            microphoneDeviceOptions: [...prevState.microphoneDeviceOptions, addedAudioDeviceOption]
                        }));
                    }
                });

                e.removed.forEach(removedAudioDevice => {
                    if (removedAudioDevice.deviceType === 'Speaker') {
                        this.setState(prevState => ({
                            speakerDeviceOptions: prevState.speakerDeviceOptions.filter(option => { return option.key !== removedAudioDevice.id })
                        }))
                    } else if (removedAudioDevice.deviceType === 'Microphone') {
                        this.setState(prevState => ({
                            microphoneDeviceOptions: prevState.microphoneDeviceOptions.filter(option => { return option.key !== removedAudioDevice.id })
                        }))
                    }
                });
            });

            this.deviceManager.on('selectedSpeakerChanged', () => {

                this.setState({ selectedSpeakerDeviceId: this.deviceManager.selectedSpeaker && this.deviceManager.selectedSpeaker.id });
            });

            this.deviceManager.on('selectedMicrophoneChanged', () => {

                this.setState({ selectedMicrophoneDeviceId: this.deviceManager.selectedMicrophone && this.deviceManager.selectedMicrophone.id });
            });

            const callStateChanged = async () => {

                const cameraDevices = await this.deviceManager.getCameras();
                const speakerDevices = await this.deviceManager.getSpeakers();
                const microphoneDevices = await this.deviceManager.getMicrophones();
                if (this.call.state !== 'None' &&
                    this.call.state !== 'Connecting' &&
                    this.call.state !== 'Incoming') {
                    if (this.callFinishConnectingResolve) {
                        this.callFinishConnectingResolve();
                    }
                }
                if (this.call.state === 'Incoming') {
                    this.setState({ selectedCameraDeviceId: cameraDevices[0] && cameraDevices[0].id });
                    this.setState({ selectedSpeakerDeviceId: speakerDevices[0] && speakerDevices[0].id });
                    this.setState({ selectedMicrophoneDeviceId: microphoneDevices[0] && microphoneDevices[0].id });
                }

                if (this.call.state !== 'Disconnected') {
                    this.setState({ callState: this.call.state });
                } if (this.call.state === "Connected" && !this.state.serverCallId) {
                    this.durationCounter()
                    this.call.info.getServerCallId().then(result => {
                        this.setState({ serverCallId: result })
                    }).catch(err => {
                        console.error(err);
                    });

                }
                if (this.call.state === "Connected") {
                    this.durationCounter()
                }
            }
            callStateChanged();
            this.call.on('stateChanged', callStateChanged);

            this.call.localVideoStreams.forEach(lvs => {
                this.setState({ videoOn: true });
            });
            this.call.on('localVideoStreamsUpdated', e => {
                e.added.forEach(lvs => {
                    this.setState({ videoOn: true });
                });
                e.removed.forEach(lvs => {
                    this.setState({ videoOn: false });
                });
            });

            this.call.on('idChanged', () => {
                this.setState({ callId: this.call.id });
            });

            this.call.on('isMutedChanged', () => {
                this.setState({ micMuted: this.call.isMuted });
            });

            this.call.on('isIncomingAudioMutedChanged', () => {
                this.setState({ incomingAudioMuted: this.call.isIncomingAudioMuted });
            });

            this.call.on('isScreenSharingOnChanged', () => {
                this.setState({ screenShareOn: this.call.isScreenShareOn });
            });

            this.call.remoteParticipants.forEach(rp => this.subscribeToRemoteParticipant(rp));
            this.call.on('remoteParticipantsUpdated', e => {
                e.added.forEach(p => {
                    this.subscribeToRemoteParticipant(p);
                });
                e.removed.forEach(p => {
                    if (p.callEndReason) {
                        message.destroy();
                        message.warning(`Remote participant ${utils.getIdentifierText(p.identifier)} disconnected: code: ${p.callEndReason.code}, subCode: ${p.callEndReason.subCode}.`, 3)

                    }
                    this.setState({ remoteParticipants: this.state.remoteParticipants.filter(remoteParticipant => { return remoteParticipant !== p }) });
                    this.setState({ allRemoteParticipantStreams: this.state.allRemoteParticipantStreams.filter(s => { return s.participant !== p }) });
                    p.off('videoStreamsUpdated', () => { });
                });
            });
            const mediaCollector = this.call.feature(Features.MediaStats).createCollector();
            this.setState({ mediaCollector });
            mediaCollector.on('sampleReported', (data) => {
                if (this.state.logMediaStats) {
                    // AzureLogger.log(`${(new Date()).toISOString()} MediaStats sample: ${JSON.stringify(data)}`);
                }
                let sentResolution = '';
                if (data && data.video && data.video.send && data.video.send.length) {
                    if (data.video.send[0].frameWidthSent && data.video.send[0].frameHeightSent) {
                        sentResolution = `${data.video.send[0].frameWidthSent}x${data.video.send[0].frameHeightSent}`
                    }
                }
                if (this.state.sentResolution !== sentResolution) {
                    this.setState({ sentResolution });
                }
                let stats = {};
                if (this.state.logMediaStats) {
                    if (data && data.video && data.video.receive && data.video.receive.length) {
                        data.video.receive.forEach(v => {
                            stats[v.streamId] = v;
                        });
                    }
                    if (data && data.screenShare && data.screenShare.receive && data.screenShare.receive.length) {
                        data.screenShare.receive.forEach(v => {
                            stats[v.streamId] = v;
                        });
                    }
                }
                this.state.allRemoteParticipantStreams.forEach(v => {
                    let renderer = v.streamRendererComponentRef.current;
                    if (renderer)
                        renderer.updateReceiveStats(stats[v.stream.id]);
                });
            });
            mediaCollector.on('summaryReported', (data) => {
                if (this.state.logMediaStats) {
                    // AzureLogger.log(`${(new Date()).toISOString()} MediaStats summary: ${JSON.stringify(data)}`);
                }
            });

            const dominantSpeakersChangedHandler = async () => {
                try {
                    if (this.state.dominantSpeakerMode) {

                        const newDominantSpeakerIdentifier = this.call.feature(Features.DominantSpeakers).dominantSpeakers.speakersList[0];
                        if (newDominantSpeakerIdentifier) {

                            // Set the new dominant remote participant
                            const newDominantRemoteParticipant = utils.getRemoteParticipantObjFromIdentifier(this.call, newDominantSpeakerIdentifier);

                            // Get the new dominant remote participant's stream tuples
                            const streamsToRender = [];
                            for (const streamTuple of this.state.allRemoteParticipantStreams) {
                                if (streamTuple.participant === newDominantRemoteParticipant && streamTuple.stream.isAvailable) {
                                    streamsToRender.push(streamTuple);
                                    if (!streamTuple.streamRendererComponentRef.current.getRenderer()) {
                                        await streamTuple.streamRendererComponentRef.current.createRenderer();
                                    };
                                }
                            }

                            const previousDominantSpeaker = this.state.dominantRemoteParticipant;
                            this.setState({ dominantRemoteParticipant: newDominantRemoteParticipant });

                            if (previousDominantSpeaker) {
                                // Remove the old dominant remote participant's streams
                                this.state.allRemoteParticipantStreams.forEach(streamTuple => {
                                    if (streamTuple.participant === previousDominantSpeaker) {
                                        streamTuple.streamRendererComponentRef.current.disposeRenderer();
                                    }
                                });
                            }

                            // Render the new dominany speaker's streams
                            streamsToRender.forEach(streamTuple => {
                                streamTuple.streamRendererComponentRef.current.attachRenderer();
                            })

                        } else {
                            console.warn('New dominant speaker is undefined');
                        }
                    }
                } catch (error) {
                    console.error(error);
                }
            };

            const dominantSpeakerIdentifier = this.call.feature(Features.DominantSpeakers).dominantSpeakers.speakersList[0];
            if (dominantSpeakerIdentifier) {
                this.setState({ dominantRemoteParticipant: utils.getRemoteParticipantObjFromIdentifier(dominantSpeakerIdentifier) })
            }

            this.call.feature(Features.DominantSpeakers).on('dominantSpeakersChanged', dominantSpeakersChangedHandler);

            const capabilitiesFeature = this.call.feature(Features.Capabilities);
            const capabilities = this.call.feature(Features.Capabilities).capabilities;
            capabilitiesFeature.on('capabilitiesChanged', () => {
                const updatedCapabilities = capabilitiesFeature.capabilities;
            });
        }
    }

    subscribeToRemoteParticipant(participant) {
        if (!this.state.remoteParticipants.find((p) => { return p === participant })) {
            this.setState(prevState => ({ remoteParticipants: [...prevState.remoteParticipants, participant] }));
        }

        const addToListOfAllRemoteParticipantStreams = (participantStreams) => {
            if (participantStreams) {
                let participantStreamTuples = participantStreams.map(stream => { return { stream, participant, streamRendererComponentRef: React.createRef() } });
                participantStreamTuples.forEach(participantStreamTuple => {
                    if (!this.state.allRemoteParticipantStreams.find((v) => { return v === participantStreamTuple })) {
                        this.setState(prevState => ({
                            allRemoteParticipantStreams: [...prevState.allRemoteParticipantStreams, participantStreamTuple]
                        }));
                    }
                })
            }
        }

        const removeFromListOfAllRemoteParticipantStreams = (participantStreams) => {
            participantStreams.forEach(streamToRemove => {
                const tupleToRemove = this.state.allRemoteParticipantStreams.find((v) => { return v.stream === streamToRemove })
                if (tupleToRemove) {
                    this.setState({
                        allRemoteParticipantStreams: this.state.allRemoteParticipantStreams.filter(streamTuple => { return streamTuple !== tupleToRemove })
                    });
                }
            });
        }

        const handleVideoStreamsUpdated = (e) => {
            addToListOfAllRemoteParticipantStreams(e.added);
            removeFromListOfAllRemoteParticipantStreams(e.removed);
        }

        addToListOfAllRemoteParticipantStreams(participant.videoStreams);
        participant.on('videoStreamsUpdated', handleVideoStreamsUpdated);
    }

    async handleVideoOnOff() {
        try {
            const cameras = await this.deviceManager.getCameras();
            const cameraDeviceInfo = cameras.find(cameraDeviceInfo => {
                return cameraDeviceInfo.id === this.state.selectedCameraDeviceId
            });
            let selectedCameraDeviceId = this.state.selectedCameraDeviceId;
            let localVideoStream
            if (this.state.selectedCameraDeviceId) {
                localVideoStream = new LocalVideoStream(cameraDeviceInfo);

            } else if (!this.state.videoOn) {
                const cameras = await this.deviceManager.getCameras();
                selectedCameraDeviceId = cameras[0].id;
                localVideoStream = new LocalVideoStream(cameras[0]);
            }

            if (this.call.state === 'None' ||
                this.call.state === 'Connecting' ||
                this.call.state === 'Incoming') {
                if (this.state.videoOn) {
                    this.setState({ videoOn: false });
                } else {
                    this.setState({ videoOn: true, selectedCameraDeviceId })
                }
                await this.watchForCallFinishConnecting();
                if (this.state.videoOn) {
                    this.call.startVideo(localVideoStream).catch(error => { });
                } else {
                    this.call.stopVideo(this.call.localVideoStreams[0]).catch(error => { });
                }
            } else {
                if (this.call.localVideoStreams[0]) {
                    await this.call.stopVideo(this.call.localVideoStreams[0]);
                } else {
                    await this.call.startVideo(localVideoStream);
                }
            }

            this.setState({ videoOn: this.call.localVideoStreams[0] ? true : false });
        } catch (e) {
            console.error(e);
        }
    }

    async watchForCallFinishConnecting() {
        return new Promise((resolve) => {
            if (this.state.callState !== 'None' && this.state.callState !== 'Connecting' && this.state.callState !== 'Incoming') {
                resolve();
            } else {
                this.callFinishConnectingResolve = resolve;
            }
        }).then(() => {
            this.callFinishConnectingResolve = undefined;
        });
    }

    async handleMicOnOff() {
        try {
            if (!this.call.isMuted) {
                await this.call.mute();
            } else {
                await this.call.unmute();
            }
            this.setState({ micMuted: this.call.isMuted });
        } catch (e) {
            console.error(e);
        }
    }



    async handleIncomingAudioOnOff() {
        try {
            if (!this.call.isIncomingAudioMuted) {
                await this.call.muteIncomingAudio();
            } else {
                await this.call.unmuteIncomingAudio();
            }
            this.setState({ incomingAudioMuted: this.call.isIncomingAudioMuted });
        } catch (e) {
            console.error(e);
        }
    }

    async handleHoldUnhold() {
        try {
            if (this.call.state === 'LocalHold') {
                this.call.resume();
            } else {
                this.call.hold();
            }
        } catch (e) {
            console.error(e);
        }
    }

    async handleOutgoingAudioEffect() {
        if (this.state.outgoingAudioMediaAccessActive) {
            this.call.stopAudio();
        } else {
            this.startOutgoingAudioEffect();
        }

        this.setState(prevState => ({ outgoingAudioMediaAccessActive: !prevState.outgoingAudioMediaAccessActive }));
    }

    async handleMediaStatsLogState() {
        this.setState(prevState => ({ logMediaStats: !prevState.logMediaStats }));
    }

    getDummyAudioStream() {
        const context = new AudioContext();
        const dest = context.createMediaStreamDestination();
        const os = context.createOscillator();
        os.type = 'sine';
        os.frequency.value = 500;
        os.connect(dest);
        os.start();
        const { stream } = dest;
        return stream;
    }

    async startOutgoingAudioEffect() {
        const stream = this.getDummyAudioStream();
        const customLocalAudioStream = new LocalAudioStream(stream);
        this.call.startAudio(customLocalAudioStream);
    }

    async handleScreenSharingOnOff() {
        try {
            if (this.call.isScreenSharingOn) {
                await this.call.stopScreenSharing()
            } else {
                await this.call.startScreenSharing();
            }
            this.setState({ screenShareOn: this.call.isScreenSharingOn });
        } catch (e) {
            console.error(e);
        }
    }

    async toggleDominantSpeakerMode() {
        try {
            if (this.state.dominantSpeakerMode) {
                // Turn off dominant speaker mode
                this.setState({ dominantSpeakerMode: false });
                // Render all remote participants's streams
                for (const streamTuple of this.state.allRemoteParticipantStreams) {
                    if (streamTuple.stream.isAvailable && !streamTuple.streamRendererComponentRef.current.getRenderer()) {
                        await streamTuple.streamRendererComponentRef.current.createRenderer();
                        streamTuple.streamRendererComponentRef.current.attachRenderer();
                    }
                }
            } else {
                // Turn on dominant speaker mode
                this.setState({ dominantSpeakerMode: true });
                // Dispose of all remote participants's stream renderers
                const dominantSpeakerIdentifier = this.call.feature(Features.DominantSpeakers).dominantSpeakers.speakersList[0];
                if (!dominantSpeakerIdentifier) {
                    this.state.allRemoteParticipantStreams.forEach(v => {
                        v.streamRendererComponentRef.current.disposeRenderer();
                    });

                    // Return, no action needed
                    return;
                }

                // Set the dominant remote participant obj
                const dominantRemoteParticipant = utils.getRemoteParticipantObjFromIdentifier(this.call, dominantSpeakerIdentifier);
                this.setState({ dominantRemoteParticipant: dominantRemoteParticipant });
                // Dispose of all the remote participants's stream renderers except for the dominant speaker
                this.state.allRemoteParticipantStreams.forEach(v => {
                    if (v.participant !== dominantRemoteParticipant) {
                        v.streamRendererComponentRef.current.disposeRenderer();
                    }
                });
            }
        } catch (e) {
            console.error(e);
        }
    }

    cameraDeviceSelectionChanged = async (event, item) => {
        const cameras = await this.deviceManager.getCameras();
        const cameraDeviceInfo = cameras.find(cameraDeviceInfo => { return cameraDeviceInfo.id === item.key });
        const localVideoStream = this.call.localVideoStreams[0];
        if (localVideoStream) {
            localVideoStream.switchSource(cameraDeviceInfo);
        }
        this.setState({ selectedCameraDeviceId: cameraDeviceInfo.id });
    };

    speakerDeviceSelectionChanged = async (event, item) => {
        const speakers = await this.deviceManager.getSpeakers();
        const speakerDeviceInfo = speakers.find(speakerDeviceInfo => { return speakerDeviceInfo.id === item.key });
        this.deviceManager.selectSpeaker(speakerDeviceInfo);
        this.setState({ selectedSpeakerDeviceId: speakerDeviceInfo.id });
    };

    microphoneDeviceSelectionChanged = async (event, item) => {
        const microphones = await this.deviceManager.getMicrophones();
        const microphoneDeviceInfo = microphones.find(microphoneDeviceInfo => { return microphoneDeviceInfo.id === item.key });
        this.deviceManager.selectMicrophone(microphoneDeviceInfo);
        this.setState({ selectedMicrophoneDeviceId: microphoneDeviceInfo.id });
    };

    updateStreamList() {
        const allStreamsBackup = [...this.state.allRemoteParticipantStreams];
        this.setState({ allRemoteParticipantStreams: [] });
        setTimeout(() => {
            this.setState({ allRemoteParticipantStreams: [...allStreamsBackup] });
        }, 0);
    }
    durationCounter = () => {

        var minutesLabel = document.getElementById("minutes");
        var secondsLabel = document.getElementById("seconds");
        var totalSeconds = 0;
        setInterval(setTime, 1000);

        function setTime() {
            ++totalSeconds;
            secondsLabel.innerHTML = pad(totalSeconds % 60);
            minutesLabel.innerHTML = pad(parseInt(totalSeconds / 60));
        }
        function pad(val) {
            var valString = val + "";
            if (valString.length < 2) {
                return "0" + valString;
            } else {
                return valString;
            }
        }
    }
    getStartRecordingbyserverCallId() {
        this.api.invoke("StartRecordingbyserverCallId/" + this.state.serverCallId, "get", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {
                    const users = data.data;
                    this.setState({ recordingId: users, isRecording: "rec" });
                } else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
            }
        });
    }
    getStopRecordingAsync() {
        this.api.invoke("StopRecordingAsync/" + this.state.serverCallId + '/' + this.state.recordingId, "get", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {
                    const users = data.data;
                    this.getRecordingFile()
                    this.setState({ isRecording: 'stop' });
                } else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
            }
        });
    }
    getPauseRecordingAsync() {
        this.api.invoke("PauseRecordingAsync/" + this.state.serverCallId + '/' + this.state.recordingId, "get", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {
                    const users = data.data;
                    this.setState({ paused: 'pause' });
                } else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
            }
        });
    }
    getResumeRecordingAsync() {
        this.api.invoke("ResumeRecordingAsync/" + this.state.serverCallId + '/' + this.state.recordingId, "get", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {
                    const users = data.data;
                    this.setState({ paused: 'play' });
                } else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
            }
        });
    }
    getRecordingFile() {
        this.api.invoke("GetRecordingFile", "post", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {
                    const users = data;
                    // this.setState({ paused: 'play' });
                } else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
            }
        });
    }
    recordHandle = (buttonType) => {

        const callRecordingApi = this.call.feature(Features.Recording)
        if (buttonType === "RSButton") {
            this.state.isRecording === "rec" ? this.getStopRecordingAsync() : this.getStartRecordingbyserverCallId();
        }
        if (buttonType === "PPButton") {
            if (this.state.paused === "play") {
                this.getPauseRecordingAsync()
            } else {
                this.getResumeRecordingAsync()
            }
        }
        // this.state.isRecording?this.getStopRecordingAsync():this.getStartRecordingbyserverCallId()

        // callRecordingApi.off('isRecordingActiveChanged',()=>{ });
        // callRecordingApi.on('isRecordingActiveChanged',()=>{ });
        // 
    }

    render() {
        const { UserId, UserProfileName, UserRoleName } = this.userPermandMasters.decodedToken;
        console.log(this.state && this.state.allRemoteParticipantStreams && this.state.allRemoteParticipantStreams.filter(v => v.stream.isAvailable === true))
        return (
            <div >
                {this.state.minimize ?
                    <div style={{ backgroundColor: "white", position: 'fixed', bottom: 0, right: 15, zIndex: 3 }}>

                        <div style={minimizePopUpout}>
                            <PageHeader
                                ghost={false}
                                title={<></>}
                                style={{ background: "#362e64", height: '35px', padding: "5px 0px" }}
                                extra={[
                                    <Button style={MinMaxButton} type="link"
                                        onClick={() => { this.setState({ minimize: false }) }}
                                    >
                                        <i className="fa  fa-window-maximize" style={{ fontSize: "22px" }} aria-hidden="true"></i>
                                    </Button>

                                ]}
                            >
                            </PageHeader>
                            <div style={{ height: '55%', display: "flex", justifyContent: 'center', alignItems: "center" }}>

                                <div style={{ backgroundColor: "rgb(78, 86, 148)", width: "100px", height: "100px", border: "2px solid rgb(78, 86, 148)", borderRadius: '50%', display: "flex", justifyContent: 'center', alignItems: "center" }}>

                                    <Icon type="user" style={{ fontSize: "35px", color: "white" }} />
                                </div>
                            </div>

                            <Row type="flex" justify="center" >
                                <Col span={5}>
                                    <Button type='link' className="connect-button" style={{ width: '45px', backgroundColor: "#362e64", padding: 0, paddingLeft: "5px" }}
                                        title={'Mute'}
                                        onClick={() => this.handleMicOnOff()}>
                                        {this.state.micMuted ? <i className="fa fa-microphone-slash" style={{ fontSize: "22px" }} aria-hidden="true"></i> : <i className="fa fa-microphone" style={{ fontSize: "22px" }} aria-hidden="true"></i>}</Button>
                                </Col>
                                <Col span={5}>
                                    <Button type='link' className="connect-button" style={{ width: '45px', backgroundColor: "#362e64", padding: 0, paddingLeft: "5px" }}
                                        title={'Screen Share'}
                                        onClick={() => this.handleScreenSharingOnOff()}>
                                        {this.state.screenShareOn ? <i className="fa fa-window-close-o " style={{ fontSize: "22px" }} aria-hidden="true"></i> : <i className="fa fa-caret-square-o-right" style={{ fontSize: "22px" }} aria-hidden="true"></i>} </Button>
                                </Col>
                                <Col span={5}>
                                    <Button type='link' className="connect-button" style={{ width: '45px', backgroundColor: "red", padding: 0, paddingLeft: '12px' }}
                                        title={'Call End'}
                                        onClick={() => { this.audio.pause(); this.call.hangUp() }}>
                                        <Icon type="phone" rotate={225} style={{ display: "flex", fontSize: '18px', color: "white" }} />
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    : <div style={maximizePopUpout}>
                        <PageHeader
                            ghost={false}
                            title={<></>}
                            style={{ background: "#362e64", height: '35px', padding: "3px" }}
                            extra={[<Button style={MinMaxButton} type="link"
                                onClick={() => { this.setState({ minimize: true }) }}
                            >
                                <i className="fa fa-window-minimize" style={{ fontSize: "22px" }} aria-hidden="true"></i>
                            </Button>
                            ]}
                        >
                        </PageHeader>
                        <div style={{ height: '45px', padding: "10px 0px" }}>
                            <Button style={{ float: "right", backgroundColor: "red", width: "fit-content" }} type="danger" onClick={() => { this.audio.pause(); this.call.hangUp() }}><Icon type="phone" rotate={225} /> Leave</Button>

                            <Button style={{ float: "right", width: '35px', height: "35px", paddingLeft: '20px', display: "flex", justifyContent: "center", alignItems: "center" }} type="link"
                                title={'video'}
                                onClick={() => { this.handleVideoOnOff(); this.setState({ showLocalVideo: !this.state.showLocalVideo }) }}
                            >
                                {this.state.videoOn ? <i style={{ fontSize: "22px" }} className="fa fa-regular fa-video"></i> : <i style={{ fontSize: "22px" }} className="fa-regular fa-video-slash"></i>}
                            </Button>
                            <Button style={{ float: "right", width: '35px', height: "35px", paddingLeft: '20px', display: "flex", justifyContent: "center", alignItems: "center" }} type="link" title={'Screen Share'}
                                onClick={() => this.handleScreenSharingOnOff()}>
                                {this.state.screenShareOn ? <i className="fa fa-window-close-o " style={{ fontSize: "22px" }} aria-hidden="true"></i> : <i className="fa fa-caret-square-o-right" style={{ fontSize: "22px" }} aria-hidden="true"></i>}
                            </Button>
                            <Button style={{ float: "right", width: '35px', height: "35px", paddingLeft: '20px', display: "flex", justifyContent: "center", alignItems: "center" }} type="link" title={'Mute'}
                                onClick={() => this.handleMicOnOff()}>

                                {this.state.micMuted ? <i className="fa fa-microphone-slash" style={{ fontSize: "22px" }} aria-hidden="true"></i> : <i className="fa fa-microphone" style={{ fontSize: "22px" }} aria-hidden="true"></i>}
                            </Button>
                            <Button style={{ float: "right", width: '35px', height: "35px", paddingLeft: '20px', display: "flex", justifyContent: "center", alignItems: "center" }} type="link" title={'Audio'}
                                onClick={() => this.handleIncomingAudioOnOff()}>

                                {this.state.incomingAudioMuted ? <i className="fa fa-volume-up" style={{ fontSize: "22px" }} aria-hidden="true"></i> : <i className="fa fa-volume-off" style={{ fontSize: "22px" }} aria-hidden="true"></i>}
                            </Button>
                            <Button style={{ float: "right", width: '35px', height: "35px", paddingLeft: '20px', display: "flex", justifyContent: "center", alignItems: "center" }} type="link" title={'Settings'}
                                onClick={() => this.setState({ showSettings: true })}>

                                <i className="fa fa-cog" aria-hidden="true"></i>
                            </Button>
                            {this.state.isRecording === "rec" && <Button style={{ float: "right", width: '35px', height: "35px", paddingLeft: '20px', display: "flex", justifyContent: "center", alignItems: "center" }} type="link" title={this.state.paused === "play" ? 'pause' : "play"}
                                onClick={() => { this.recordHandle('PPButton') }}>

                                {this.state.paused === "play" ? <i className="fa fa-pause" aria-hidden="true"></i> : <i className="fa fa-play" aria-hidden="true"></i>}
                            </Button>}
                            <Button style={{ float: "right", width: '35px', height: "35px", paddingLeft: '20px', display: "flex", justifyContent: "center", alignItems: "center" }} type="link" title={this.state.isRecording === "rec" ? 'stop' : "rec"}
                                onClick={() => { this.recordHandle('RSButton') }}>

                                {this.state.isRecording === "rec" ? <i className="fa fa-stop" aria-hidden="true"></i> : <i className="fa fa-dot-circle-o" aria-hidden="true"></i>}
                            </Button>
                            <Switch style={{ float: "right", marginTop: '7px' }} label={
                                <div>
                                    Dominant Speaker mode{' '}
                                    <Tooltip content={`Render the most dominant speaker's video streams only or render all remote participant video streams`}>
                                        <Icon type="Info" aria-label="Info tooltip" />
                                    </Tooltip>
                                </div>
                            }
                                styles={{
                                    text: { color: '#edebe9' },
                                    label: { color: '#edebe9' },
                                }}

                                onChange={() => { this.toggleDominantSpeakerMode() }}
                            />
                            <span style={{ width: '35px', height: "35px", paddingLeft: '20px', display: "flex", justifyContent: "center", alignItems: "center" }}><p id="minutes">00</p><p>:</p><p id="seconds">00</p></span>
                        </div>
                        <Row >
                            <Col span={24}>
                                <span><h3 style={{ marginLeft: 20, fontSize: 25 }}>Participants</h3></span>
                                <h2 style={{ textAlign: "center" }}>{`${this.state.callState}...`}</h2>
                            </Col>
                            <Col span={24}>
                                {
                                    <Row style={{ margin: "5px" }}>
                                        {
                                            (this.state.callState === 'Connected' ||
                                                this.state.callState === 'LocalHold' ||
                                                this.state.callState === 'RemoteHold') &&

                                                this.state.allRemoteParticipantStreams.filter(v => v.stream.mediaStreamType === "ScreenSharing").filter(v => v.stream.isAvailable === true).length > 0 ? [this.state.allRemoteParticipantStreams.filter(v => v.stream.mediaStreamType === 'ScreenSharing').filter(v => v.stream.isAvailable === true).map(v => {
                                                    return <Col span={18}>
                                                        <StreamRenderer
                                                            data={this.state.allRemoteParticipantStreams}
                                                            UserProfileName={UserProfileName}
                                                            showLocalVideo={this.state.showLocalVideo}
                                                            selectedCameraDeviceId={this.state.selectedCameraDeviceId} deviceManager={this.deviceManager}
                                                            remoteParticipants={this.state.remoteParticipants}
                                                            key={`${utils.getIdentifierText(v.participant.identifier)}-${v.stream.mediaStreamType}-${v.stream.id}`}
                                                            ref={v.streamRendererComponentRef}
                                                            stream={v.stream}
                                                            isvideoOn={true}
                                                            remoteParticipant={v.participant}
                                                            dominantSpeakerMode={this.state.dominantSpeakerMode}
                                                            dominantRemoteParticipant={this.state.dominantRemoteParticipant}
                                                            call={this.call}
                                                            maximumNumberOfRenderers={this.maximumNumberOfRenderers}
                                                            updateStreamList={() => this.updateStreamList()}
                                                        />
                                                    </Col>
                                                }),
                                                <Col span={6.5}>
                                                    {this.state.allRemoteParticipantStreams.filter(v => v.stream.mediaStreamType === "Video").map(v => {
                                                        return <StreamRenderer
                                                            data={this.state.allRemoteParticipantStreams}
                                                            UserProfileName={UserProfileName}
                                                            showLocalVideo={this.state.showLocalVideo}
                                                            selectedCameraDeviceId={this.state.selectedCameraDeviceId} deviceManager={this.deviceManager}
                                                            isvideoOn={true}
                                                            remoteParticipants={this.state.remoteParticipants}
                                                            key={`${utils.getIdentifierText(v.participant.identifier)}-${v.stream.mediaStreamType}-${v.stream.id}`}
                                                            ref={v.streamRendererComponentRef}
                                                            stream={v.stream}
                                                            remoteParticipant={v.participant}
                                                            dominantSpeakerMode={this.state.dominantSpeakerMode}
                                                            dominantRemoteParticipant={this.state.dominantRemoteParticipant}
                                                            call={this.call}
                                                            maximumNumberOfRenderers={this.maximumNumberOfRenderers}
                                                            updateStreamList={() => this.updateStreamList()}
                                                        />
                                                    })}
                                                </Col>
                                            ]
                                                : <Col span={24} style={{ display: "flex", justifyContent: "center", alignItems: "center", flexWrap: "wrap" }}>
                                                    {this.state.allRemoteParticipantStreams.filter(v => v.stream.mediaStreamType === "Video").map(v => {
                                                        return <StreamRenderer
                                                            data={this.state.allRemoteParticipantStreams}
                                                            UserProfileName={UserProfileName}
                                                            showLocalVideo={this.state.showLocalVideo}
                                                            selectedCameraDeviceId={this.state.selectedCameraDeviceId} deviceManager={this.deviceManager}
                                                            isvideoOn={false}
                                                            remoteParticipants={this.state.remoteParticipants}
                                                            key={`${utils.getIdentifierText(v.participant.identifier)}-${v.stream.mediaStreamType}-${v.stream.id}`}
                                                            ref={v.streamRendererComponentRef}
                                                            stream={v.stream}
                                                            remoteParticipant={v.participant}
                                                            dominantSpeakerMode={this.state.dominantSpeakerMode}
                                                            dominantRemoteParticipant={this.state.dominantRemoteParticipant}
                                                            call={this.call}
                                                            maximumNumberOfRenderers={this.maximumNumberOfRenderers}
                                                            updateStreamList={() => this.updateStreamList()}
                                                        />
                                                    }
                                                    )}
                                                </Col>}
                                                <Col span={ this.state.allRemoteParticipantStreams.filter(v => v.stream.mediaStreamType === "ScreenSharing").filter(v => v.stream.isAvailable === true).length > 0 ?0:18}></Col>
                                <Col span={ this.state.allRemoteParticipantStreams.filter(v => v.stream.mediaStreamType === "ScreenSharing").filter(v => v.stream.isAvailable === true).length > 0 ?6.5:6} style={{ display: "flex", justifyContent: "end" }}>
                                    {
                                        this.state.showLocalVideo ?
                                            <div className="mb-3" >
                                                <LocalVideoPreviewCard selectedCameraDeviceId={this.state.selectedCameraDeviceId} deviceManager={this.deviceManager} />
                                            </div> :
                                            <div className="mb-3" style={{
                                                backgroundColor: 'rgba(245, 245, 251, 0.8)',
                                                height: '170px',
                                                width: '300px',
                                                margin: '10px',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                border: "2px solid rgb(78, 86, 148)",
                                                alignItems: 'center',
                                                borderRadius: "5px"
                                            }}>
                                                <div style={{ border: "2px solid rgb(78, 86, 148)", borderRadius: '50%', display: "flex", placeContent: "center", width: '100px', height: "100px", backgroundColor: "rgb(78, 86, 148)" }}>
                                                    <p style={{ margin: "auto", fontSize: "30px", color: "white" }}>
                                                        {UserProfileName && UserProfileName.split(" ").map((item) => item.charAt(0)).join("").toUpperCase()}
                                                    </p>
                                                </div>
                                            </div>
                                    }
                                </Col>
                                    </Row>
                                }
                            </Col>
                            <Drawer
                                width={440}
                                visible={this.state.showSettings}
                                onClose={() => this.setState({ showSettings: false })}
                                title="Basic Drawer"
                                placement="right"
                                closable={false}

                            >
                                <Col>
                                    <div className="pl-2 mt-3">
                                        <div className="pl-2">
                                            <div className="participants-panel-title custom-row text-center">
                                                <AddParticipantPopover
                                                    userPermandMasters={this.userPermandMasters}
                                                    call={this.call}
                                                    loginuser={this.props.loginuser}
                                                    GetUserTokenandIdentitybyId={
                                                        this.props.GetUserTokenandIdentitybyId
                                                    }
                                                    chatClient={this.props.chatClient}

                                                    thread={this.props.thread} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pl-2 mt-4">
                                        <h3>Sound Settings</h3>
                                        <div className="pl-2">
                                            <div >
                                                {
                                                    (this.state.callState === 'Connected') && !this.state.micMuted && !this.state.incomingAudioMuted &&
                                                    <h3>Volume Visualizer</h3>
                                                }
                                                {
                                                    (this.state.callState === 'Connected') && !this.state.micMuted && !this.state.incomingAudioMuted &&
                                                    <VolumeVisualizer call={this.call} deviceManager={this.deviceManager} remoteVolumeLevel={this.state.remoteVolumeLevel} />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                            </Drawer>
                        </Row>

                    </div>}

            </div >

        );
    }
}
